export default "__VITE_ASSET__c8d78756__"